export default __webpack_public_path__ + "static/media/background.b530f84d.jpg";